<template>
  <div class="content-container" v-loading="loading">
     <ContentBox title="查看广告主" class="content-box">
      <el-form
         class="demo-ruleForm"
        label-width="120px"
        label-position="left"
        :model="qualificationForm">
        <el-form-item label="类型">
          <template v-if="qualificationForm.registerType === 0">
            企业
          </template>
          <template v-else>
            个人
          </template>
        </el-form-item>
        <template v-if="qualificationForm.registerType === 0">
          <el-form-item label="公司名称">
            {{qualificationForm.partnerName}}
          </el-form-item>
          <el-form-item label="证件类型">
            {{$consts.companyNatureText[qualificationForm.companyNature]}}&nbsp;&nbsp;
            {{$consts.licenseTypeText[qualificationForm.licenseType] }}
          </el-form-item>
          <el-form-item label="资质照片">
            <template v-if="qualificationForm.license">
            <img :src="qualificationForm.license">
            </template>
          </el-form-item>
          <el-form-item label="资质编号">
            {{qualificationForm.licenseSn}}
          </el-form-item>
          <el-form-item label="证件有效期">
            <template v-if="qualificationForm.licenseUsefulLifeTime">
            {{$moment(qualificationForm.licenseUsefulLifeTime).format('YYYY-MM-DD')}}
            </template>
            <template v-else>
            </template>
          </el-form-item>
          <el-form-item label="法人/经营者">
          {{qualificationForm.legalPerson}}
          </el-form-item>
          <el-form-item label="法人身份证">
              <img v-if="qualificationForm.identityCardFront !== ''" :src="qualificationForm.identityCardFront">
              <img v-if="qualificationForm.identityCardContrary !== ''" :src="qualificationForm.identityCardContrary">
          </el-form-item>
          <el-form-item label="法人身份证号">
            {{qualificationForm.identityCardNo}}
          </el-form-item>
          <el-form-item label="注册地">
            {{qualificationForm.provincesName}}&nbsp;&nbsp;
            {{qualificationForm.regionName}}
          </el-form-item>
          <el-form-item label="关联业务员">
            {{relateAgentAccountName}}
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="个人姓名">
            {{qualificationForm.partnerName}}
          </el-form-item>
          <el-form-item label="证件类型">
            <template v-if="qualificationForm.licenseType === 0">
              身份证号
            </template>
            <template v-else-if="qualificationForm.licenseType === 1">
              护照号
            </template>
            <template v-else>
              个人港澳/台湾居民往来大陆通行证证号
            </template>
          </el-form-item>
          <el-form-item label="证件照片" class="avatar-uploader-me">
              <img v-if="qualificationForm.identityCardFront !== ''" :src="qualificationForm.identityCardFront">
              <img v-if="qualificationForm.identityCardContrary !== ''" :src="qualificationForm.identityCardContrary" >
              <img v-if="qualificationForm.license !== ''" :src="qualificationForm.license">
          </el-form-item>
          <el-form-item label="证件编号" prop="qualificationCode">
            {{qualificationForm.identityCardNo}}
          </el-form-item>
          <el-form-item label="证件有效期">
              <template v-if="qualificationForm.licenseUsefulLifeTime">
                  {{$moment(qualificationForm.licenseUsefulLifeTime).format('YYYY-MM-DD')}}
            </template>
            <template v-else>
            </template>
          </el-form-item>
        </template>
      </el-form>
     </ContentBox>
     <!-- <ContentBox title="操作日志" class="content-box">
        <Table
          :props="logTable.props"
          :header="logTable.header"
          :data="logTable.data"
        />
      </ContentBox> -->
     <ContentBox>
        <el-button @click="handleQuit"><i class="icon-ios-undo"></i>返回列表</el-button>
     </ContentBox>
  </div>
</template>
<script>
export default {
  props: ['mode', 'id'],
  data() {
    return {
      loading: false,
      activeName: 'entityQualification',
      qualificationForm: {
        registerType: 0,
        partnerName: '',
        companyNature: '',
        licenseType: '',
        license: '', // 资质图片或手持图片
        licenseSn: '', // 编号
        licenseUsefulLifeTime: undefined, // 有效期
        legalPerson: '', // 法人/经营者
        identityCardFront: '', // 证件照正面
        identityCardContrary: '', // 证件照反面
        identityCardNo: '', // 身份证号
        registeredAddress: '' // 注册地址
      },
      relateAgentAccountName: '',
      agentAccountIdList: [],
      regAddress: {
        provincesId: '',
        regionId: ''
      },
      uploadImgUrl: 'api/dsp/adDspPartner/uploadFile',
      regionsData: [],
      regionsDataChild: [],
      regionId: undefined,
      companyNatureList: ['企业', '个体账户', '政府组织机构/事业单位', '港澳台', '其他机构', '海外'],
      licenseTypeList: ['组织机构代码代号', '企业营业执照统一社会信用代码', '企业营业执照注册号'],
      licenseTypeMeList: ['身份证号', '护照号', '个人港澳/台湾居民往来大陆通行证证号'],
      logTable: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '操作时间',
            align: 'left',
            prop: 'createTime',
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return h('TimeFormat', {
                props: {
                  value: row.createTime
                }
              })
            }
          },
          {
            label: '操作人',
            prop: 'operator',
            align: 'left',
            'show-overflow-tooltip': true
          },
          {
            label: '操作类型',
            prop: 'type',
            align: 'left',
            'show-overflow-tooltip': true
          },
          {
            label: '执行结果',
            prop: 'description',
            align: 'left',
            'show-overflow-tooltip': true
          }
        ],
        data: []
      }
    }
  },
  methods: {
    getRegionList() {
      this.loading = true
      this.$service.getRegionList({}).then(data => {
        const areaData = data.slice().filter(item => {
          return item.name !== '未匹配'
        })
        areaData.forEach(item => {
          if (item.parent === 0) {
            this.regionsData.push({
              value: item.regionId,
              label: item.name,
              children: []
            })
          }
        })
        for (let i = 0; i < this.regionsData.length; i++) {
          for (let j = 0; j < areaData.length; j++) {
            if (areaData[j].parent === this.regionsData[i].value) {
              this.regionsData[i].children.push({
                value: areaData[j].regionId,
                label: areaData[j].name
              })
            }
          }
        }
        if (this.mode === 'read') {
          this.getAccAdDspPartnerDetail()
        } else {
          this.loading = false
        }
      })
    },
    handleRegionsDataChange() {
      const regData = this.regionsData
      for (let i = 0; i < regData.length; i++) {
        if (regData[i].value === this.regAddress.provincesId) {
          this.regionsDataChild = regData[i].children
          for (let i = 0; i < this.regionsDataChild.length; i++) {
            if (this.regionsDataChild[i].value === this.regAddress.regionId) {
              this.qualificationForm.regionName = this.regionsDataChild[i].label
              break
            }
          }
          break
        }
      }
    },
    handleQuit() {
      this.$emit('go-back', false)
    },
    getAdAgentAccountList() {
      const params = {
        flag: 2
      }
      this.$service.getAdAgentAccountList(params).then(data => {
        this.relateAgentAccountName = (data || []).filter(item => this.agentAccountIdList.includes(item.agentAccountId)).map(item => item.agentAccountName).join()
      }).catch(() => {})
    },
    getAccAdDspPartnerDetail() {
      this.loading = true
      this.$service.getAccAdDspPartnerDetail({ partnerId: this.id }).then(data => {
        this.agentAccountIdList = data.agentAccountIdList || []
        this.qualificationForm = data
        this.qualificationForm.identityCardNo = this.$decrypt(data.identityCardNo)
        this.logTable.data = data.partnerLogList
        const addr = data.registeredAddress.split(',')
        if (addr[0]) this.regAddress.provincesId = parseInt(addr[0])
        if (addr[1]) this.regAddress.regionId = parseInt(addr[1])
        for (let i = 0; i < this.regionsData.length; i++) {
          if (this.regionsData[i].value === this.regAddress.provincesId) {
            this.qualificationForm.provincesName = this.regionsData[i].label
            break
          }
        }
        this.loading = false
        this.handleRegionsDataChange()
        this.getAdAgentAccountList()
      }).catch(() => {
        this.loading = false
      })
    }
  },
  created() {
    this.getRegionList()
  }
}
</script>
<style lang="stylus" scoped>
.content-container {
  margin: 16px;
}

>>>.title {
  padding-left: 32px;
}

>>>.content-box__main {
  margin-left: 32px;
}
img {
  width 100px
  height 100px
  margin-right 16px
  border-radius 4px
}
</style>
